import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Box } from '@material-ui/core';
import KenTextLabel from '../KenTextLabel';
import InputBase from '@material-ui/core/InputBase';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(2),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    // backgroundColor: '#FAFBFC',
    border: '1px solid #ced4da',
    fontSize: '12px',
    padding: '5px 8px 5px 5px',
    textAlign: 'left',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    // '&:focus': {
    //   borderRadius: 4,
    //   borderColor: '#80bdff',
    //   boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    // },
    // '&::placeholder': {
    //   Text: 'hello',
    // },
    //   ...inputStyles,
  },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    width: '100%',
  },
}));

export default function DateAndTimePickers(props) {
  const {
    name,
    placeholder,
    label,
    id,
    value,
    required,
    disabled,
    readonly,
    type,
    optionalLabel,
    defaultValue,
    inputBaseRootClass,
    onChange,
  } = props;
  const classes = useStyles();
  return (
    <Box>
      <KenTextLabel
        placeholder={placeholder}
        label={label}
        required={required}
        optionalLabel={optionalLabel}
      />

      <BootstrapInput
        id={id}
        name={name}
        type={type}
        disabled={disabled || readonly}
        onChange={onChange}
        defaultValue={defaultValue}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
        value={value}
        classes={{ root: inputBaseRootClass }}
      />
    </Box>
  );
}

DateAndTimePickers.defaultProps = {
  type: 'datetime-local',
};
